import React from 'react';

const images = require.context('../../Assets/emoji', true);

const Management = () => {
  const emoji = images(`./Emoji1.svg`);
  return (
    <div className="management">
      <div className="report-header">
        <div className="title">
          <h4>Your Report</h4>
          <p>Dive in to the data today.</p>
        </div>
      </div>
      <div className="employee-list">
        <div className="employee-row">
          <img src={emoji} alt="emoji" />
          <div className="left-side">
            <div className="name">John Palmer</div>
            <div className="position">Customer Service Manager</div>
          </div>
          <div>
            <div className="name">Reason:</div>
            <div className="position">115% increase in sick leave</div>
          </div>
        </div>
        <div className="employee-row">
          <img src={emoji} alt="emoji" />
          <div className="left-side">
            <div className="name">John Palmer</div>
            <div className="position">Customer Service Manager</div>
          </div>
          <div>
            <div className="name">Reason:</div>
            <div className="position">115% increase in sick leave</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Management;
